/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Delete_EventInputs */



/**
* | output |
* | --- |
* | "Delete selected event(s)" |
*
* @param {Shortcut_Keys_Desc_Delete_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_delete_event = /** @type {((inputs?: Shortcut_Keys_Desc_Delete_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Delete_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le(s) evenement(s) selectionne(s)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewähltes(e) Ereignis(se) löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранное событие(я)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स को डिलीट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir evento(s) selecionado(s)")
	return /** @type {LocalizedString} */ ("Delete selected event(s)")
});